<template lang="pug">
.carrier-selection
  .entity-content.pa-5
    v-row
      v-col
        h2.primary--text {{ $t('Shipment.carrierSelection') }}
    v-row(v-if="shipmentHasQuotes")
      v-col
        h5.red--text {{ $t('Shipment.carrierSelectionWarning') }}
    v-row
      v-col
        v-expansion-panels(
          popout,
        )
          v-expansion-panel(
            v-for="(item, i) in value",
            :key="i",
          )
            v-expansion-panel-header Route: {{ item.routeName }}
            v-expansion-panel-content
              route-layout(v-model="item.legs" v-bind="{ carriers }")
    v-row
      v-spacer
      v-col(cols="auto")
        g-btn(
          color="primary",
          @click="saveSelection",
          :disabled="saving",
        ) Save selection
</template>

<script>
import EntityMixin from '@/mixins';
import RouteLayout from '@/components/Shipment/RouteLayout';
import axios from 'axios';

export default {
  mixins: [EntityMixin],
  components: {
    RouteLayout,
  },
  props: {
    errors: {
      type: Object,
      default: () => ({}),
    },
    slotProps: null,
  },
  data: () => ({
    carriers: [],
    value: [],
    saving: false,
  }),
  methods: {
    async saveSelection() {
      try{
        this.saving = true;
        // console.log('Save ', JSON.stringify(this.saveValue));
        this.$store.commit('SET_INSTANCE_PATH', { path: 'buildQuotesJson', value: JSON.stringify(this.saveValue) });
        this.$emit('save');
      } catch(error) {
        console.log(error);
      } finally {
        this.saving = false;
      }
    },
    async loadCarriers() {
      try{
        this.carriers = (await axios.get('Carrier', {params: { pageSize: -1 }})).data.data;
      } catch(error) {
        console.log(error);
      }
    },
    getSavedCarriers(legId, savedLegs) {
      return (_.find(savedLegs, ['legId', legId]) || {}).carriersId;
    },
    loadSavedLegs(currentValue, savedLegs) {
      const copyValue = _.cloneDeep(currentValue);
      const copyLegs = _.cloneDeep(savedLegs);

      for (let { legs } of copyValue) {
        for (let leg of legs) {
          const savedCarriers = this.getSavedCarriers(leg.legId, copyLegs);
          if (savedCarriers && savedCarriers.length) {
            leg.carriersId = savedCarriers
          }
        }
      }

      return copyValue;
    },
  },
  computed: {
    saveValue() {
      return _.reduce(this.value, (acc, { legs }) => {
        return _.concat(acc, legs);
      }, [])
    },
    shipmentHasQuotes() {
      const quotes = _.get(this.instance, 'quotes');
      return Boolean(quotes) && quotes.length;
    },
  },
  async created() {
    try {
      this.loadCarriers();
      const legsBase = _.get(this.instance, 'legs', []);
      this.value = _.chain(legsBase)
        .groupBy('routeName')
        .map((value, key) => {
          const legs = _.map(value, ({ name, id, transportMode }) => ({ name, transportMode, legId: id, carriersId: [] }));
          return { routeName: key, legs };
        })
        .value();

      let savedLegs = null;
      if (savedLegs = _.get(this.instance, 'buildQuotesJson')) {
        savedLegs = JSON.parse(savedLegs);
        this.value = this.loadSavedLegs(this.value, savedLegs);
      }
    } catch(error) {
      console.log(this.$cleanString(error));
    }
  },
}
</script>
